import { EventEmitter } from '@angular/core';
import { GRID_VIEW, LIST_VIEW, ThemeConfig } from '../../../core/helpers/theme-config';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { CombinedFacets } from '../../../facets/models/facet';
var gridTileSizeXXL = ThemeConfig.get('catalog', 'grid-tile-size-xxl');
var gridTileSizeXL = ThemeConfig.get('catalog', 'grid-tile-size-xl');
var gridTileSizeLG = ThemeConfig.get('catalog', 'grid-tile-size-lg');
var gridTileSizeMD = ThemeConfig.get('catalog', 'grid-tile-size-md');
var gridTileSizeSM = ThemeConfig.get('catalog', 'grid-tile-size-sm');
var gridTileSizeXXLFullwidth = ThemeConfig.get('catalog', 'grid-tile-size-xxl-fullwidth');
var gridTileSizeXLFullwidth = ThemeConfig.get('catalog', 'grid-tile-size-xl-fullwidth');
var gridTileSizeLGFullwidth = ThemeConfig.get('catalog', 'grid-tile-size-lg-fullwidth');
var gridTileSizeMDFullwidth = ThemeConfig.get('catalog', 'grid-tile-size-md-fullwidth');
var gridTileSizeSMFullwidth = ThemeConfig.get('catalog', 'grid-tile-size-sm-fullwidth');
var gridClasses = [
    "col-xxl-" + gridTileSizeXXL,
    "col-xl-" + gridTileSizeXL,
    "col-lg-" + gridTileSizeLG,
    "col-md-" + gridTileSizeMD,
    "col-sm-" + gridTileSizeSM
];
var gridClassesFullWidth = [
    "col-xxl-" + gridTileSizeXXLFullwidth,
    "col-xl-" + gridTileSizeXLFullwidth,
    "col-lg-" + gridTileSizeLGFullwidth,
    "col-md-" + gridTileSizeMDFullwidth,
    "col-sm-" + gridTileSizeSMFullwidth
];
var ProductsComponent = /** @class */ (function () {
    function ProductsComponent(store) {
        this.store = store;
        this.loaded = false;
        this.onDetails = new EventEmitter();
        this.onFavoriteToggle = new EventEmitter();
        this.onAddCart = new EventEmitter();
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(ProductsComponent.prototype, "gridViewType", {
        get: function () {
            return GRID_VIEW;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsComponent.prototype, "listViewType", {
        get: function () {
            return LIST_VIEW;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductsComponent.prototype, "groupedProductsListType", {
        get: function () {
            return 'grouped-products-view';
        },
        enumerable: true,
        configurable: true
    });
    ProductsComponent.prototype.loaderItemsCount = function (fullWidth) {
        if (fullWidth === void 0) { fullWidth = false; }
        return 12 / (fullWidth ? gridTileSizeXXLFullwidth : gridTileSizeXXL);
    };
    ProductsComponent.prototype.gridClasses = function (fullWidth) {
        if (fullWidth === void 0) { fullWidth = false; }
        return fullWidth ? gridClassesFullWidth : gridClasses;
    };
    Object.defineProperty(ProductsComponent.prototype, "hasProducts", {
        get: function () {
            return this.products && !!this.products.length;
        },
        enumerable: true,
        configurable: true
    });
    ProductsComponent.prototype.cartProduct = function (product) {
        return this.cartProducts[product._id];
    };
    ProductsComponent.prototype.openDetails = function (product) {
        this.onDetails.emit(product);
    };
    ProductsComponent.prototype.isFavorite = function (product) {
        if (product && this.favoritesProducts)
            return !!this.favoritesProducts.find(function (item) { return product.code === item.productCode; });
        return false;
    };
    ProductsComponent.prototype.toggleFavorite = function (e) {
        this.onFavoriteToggle.emit(e);
    };
    ProductsComponent.prototype.addCart = function (event) {
        this.onAddCart.emit(event);
    };
    return ProductsComponent;
}());
export { ProductsComponent };
